import axios from "axios";
import { BASE_URL } from "../Config/globalParams";

//retourner les données d'agent
  export const getMyAgentProfile = (tenant, userId, token)  => {
    return new Promise((resolve) => {
      const url = `${BASE_URL}/MyAgentProfile/${tenant}/${userId}?token=${token}`;
      axios.get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.error(`Erreur lors de la récupération du profil d'agent :`, error);
          resolve({}); 
        });
    });
  };
  // retourner les scopes
  export const getScopes = (tenant,token)  => {
    return new Promise((resolve) => {
      const url = `${BASE_URL}/ScopeManagement/${tenant}/get/ALL?token=${token}`;
      axios.get(url)
        .then((response) => {
          
          resolve(response.data); 
        })
        .catch((error) => {
          console.error(`Erreur lors de la récupération des scopes :`, error);
          resolve({}); 
        });
    });
  };
//retourner les queues
export const getQueue = (tenant, scope, queueId, userId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/QueueManagement/${tenant}/${scope}/get/${queueId}?userid=${userId}`;
    axios.get(url)
      .then((response) => {
       
        resolve(response.data); 
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération des queues :`, error);
        resolve({})
      });
  });
};


//retourner les groupes
export const getGroups = (tenant, scope, groupId, userId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/GroupManagement/${tenant}/${scope}/get/${groupId}?userid=${userId}`;
    axios.get(url)
      .then((response) => {
        
        resolve(response.data); 
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération des groups :`, error);
        resolve([]) ;
      });
  });
};

//retourner les callFlows
export const getCallFlows = (tenant, scope,userId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/CallFlowManagement//${tenant}/${scope}/get/ALL?userid=${userId}`;
    axios.get(url)
      .then((response) => {
        
        resolve(response.data); 
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération des flux d'appels :`, error);
        resolve({});
      });
  });
};

// return the agent's connected calls
export const getAgentConnectedCalls = (tenantId, agentId, token) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/GetAgentConnectedCalls/${tenantId}/${agentId}?token=${token}`;
    axios
      .get(url)
      .then((response) => {
        resolve(response.data); 
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération des appels connectés :`, error);
        resolve({});
      });
  });
};
//Retrieve other agent information
export const getAgentInformation = (tenantId,profileScope, agentId, tz, tasks = true) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL}/AgentPerformance/${tenantId}/${profileScope}/${agentId}?tz=${tz}&tasks=${tasks}`;
    axios
      .get(url)
      .then((response) => {
        resolve(response.data); 
      })
      .catch((error) => {
        console.error(`Erreur lors de la récupération des informations de l'agent :`, error);
        resolve({}); 
      });
  });
};

